<template>
  <el-dialog
    class="dialogReviewPendingMems"
    :visible="true"
    title="Yêu cầu tham gia nhóm"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :show-close="false"
    width="300px">
    <div
      slot="title"
      class="font-16 fw-500 text-center">
      Yêu cầu tham gia nhóm
    </div>
    <div class="flex-column mx-12 pb-2 rounded-2">
      <div v-if="!pendingMems.length" class="text-center py-2">
        Không có yêu cầu tham gia!
      </div>
      <div
        v-for="item in pendingMems"
        :key="item.id">
        <div
          class="mt-2 d-flex align-items-center"
          style="height: 48px">
          <div class="d-flex align-items-center flex-1 px-12">
            <div class="d-flex align-items-center flex-1">
              <img
                :src="item.avatar"
                class="rounded-circle me-2 pointer"
                width="40"
                @click="item.accountId !== item.id && showInfo(item)" />
              <div class="d-flex flex-column">
                <span class="font-14 fw-500">{{ item.dpn }}</span>
                <span
                  class="font-14 trim-text-1-line"
                  style="max-width: 220px">
                  {{ item.user_submit }}
                  <div>
                    <span
                      class="highlight-text me-1 text-red500 fw-semibold"
                      @click="onAcceptRequestJoinGroup(0, item.uid)">
                      Từ chối
                    </span>
                    <span
                      class="highlight-text fw-semibold text-blue600"
                      @click="onAcceptRequestJoinGroup(1, item.uid)">
                      Duyệt
                    </span>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex mt-3 justify-content-end">
        <el-button
          type="info"
          size="small"
          @click="$emit('close')">
          Đóng
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["conversation"],
  data() {
    return {
      pendingMems: [],
    };
  },
  methods: {
    getPendingMems() {
      this.$http
        .post("/api/message/pendingMemsGroup", {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
        })
        .then((res) => {
          this.pendingMems = res.data.data.users || [];
        });
    },
    onAcceptRequestJoinGroup(value, uid) {
      this.$http
        .post("/api/message/reviewJoinGroup", {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          isApprove: value,
          members: [uid],
        })
        .then(() => {
          this.alert("success", `${value ? "Duyệt" : "Từ chối"} thành công!`);
          this.getPendingMems();
          if (value) {
            this.$bus.$emit("AcceptMemsJoinGroup", this.conversation);
          }
        });
    },
  },
  mounted() {
    this.getPendingMems();
  },
};
</script>

<style lang="scss">
.dialogReviewPendingMems {
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0.5rem !important;
  }
  .highlight-text:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>